import default_es_digital_store from '../es/digitalStoreMessages'

export default {
  ...default_es_digital_store,
  digitalStoreName: 'Sítio Virtual',
  digitalStoreStatus: 'Estatus de Sitio Virtual',
}
